interface MonthDays {
  [key: number]: {
    [key: number]: number
  }
}

const monthDays: MonthDays = {
  2024: {
    1: 31,
    2: 29, // Leap year
    3: 31,
    4: 30,
    5: 31,
    6: 30,
    7: 31,
    8: 31,
    9: 30,
    10: 31,
    11: 30,
    12: 31
  },
  2025: {
    1: 31,
    2: 28,
    3: 31,
    4: 30,
    5: 31,
    6: 30,
    7: 31,
    8: 31,
    9: 30,
    10: 31,
    11: 30,
    12: 31
  },
  2026: {
    1: 31,
    2: 28,
    3: 31,
    4: 30,
    5: 31,
    6: 30,
    7: 31,
    8: 31,
    9: 30,
    10: 31,
    11: 30,
    12: 31
  }
};

export const getMonthDays = (year: number, month: number): number => {
  if (!monthDays[year] || !monthDays[year][month]) {
    throw new Error(`Invalid year (${year}) or month (${month}). Only years 2024-2026 are supported.`);
  }
  return monthDays[year][month];
};
